<template></template>

<script>
import { mapState } from "vuex";

export default {
	name: "StepValidator",
	computed: {
		...mapState({
			config: state => state.configurator.config,
			stepOptionStatuses: state => state.configurator.stepOptionStatuses
		})
	},
	methods: {
		/**
		 * Returns true if no invalid options are found for the current step
		 */
		isValidCurrentStep() {
			const self = this;
			let stepValidationErrors = [];
			this.$store.getters["configurator/currentStepOptions"].forEach(option => {
				if (self.stepOptionStatuses[option] === false) {
					stepValidationErrors.push(option);
				}
			});

			// Always update validation errors to store
			this.$store.dispatch("configurator/setInvalidOptions", stepValidationErrors);

			return stepValidationErrors.length === 0;
		},
		/**
		 * Returns true if no invalid options are found for any step before target step
		 * Returns false if an invalid step was found before the target step
		 */
		isValidSteps(targetStepId) {
			const self = this;
			let invalidStep = null;
			let stepValidationErrors = [];
			let targetStepReached = false;
			// Loop through $store.stepOptionStatuses
			Object.keys(this.stepOptionStatuses).some((optionId, index) => {
				// If an invalidated step option is found, find the step it belongs to
				if (self.stepOptionStatuses[optionId] === false) {
					// Loop through the base product step.options to find the step with the invalidated option
					self.config.steps.some(step => {
						targetStepReached = targetStepId === step.id;
						if (targetStepReached) {
							// Exit loop
							return true;
						}

						if (step.options && step.options.indexOf(optionId) > -1) {
							invalidStep = step.id;
							// Add step validation error
							stepValidationErrors.push(optionId);
						}
						return false;
					});

					if (!targetStepReached) {
						return false;
					} else {
						// Exit loop
						return true;
					}
				}
			});

			// Always update validation errors to store
			this.$store.dispatch("configurator/setInvalidOptions", stepValidationErrors);
			// Always update the invalid step to store
			this.$store.dispatch("configurator/setInvalidStep", invalidStep);

			return !this.invalidStep;
		}
	}
};
</script>